import * as React from 'react';
import { Helmet } from 'react-helmet';

type Props = {
  canonicalUrl: string;
};

export default function EntityPageCanonicalTag({ canonicalUrl }: Props) {
  return (
    <Helmet>
      <link itemProp="url" rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
}
